import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters('ticketSale', [
            'singleEventInformation',
            'isBinListValidated',
            'isEventOnPresale',
            'singleEventTicketDates',
            'loadedPricesCount',
            'pricesAlreadyLoadedOneTime',
            'singleEventMode',
        ]),
        isFullyLoaded() {
            if (this.pricesAlreadyLoadedOneTime) {
                return true;
            }
            if (this.singleEventMode === 'calendar' || this.singleEventMode === 'map') {
                return true;
            }
            const dates = this.filteredEventDates();
            const priceCount = dates.reduce((carry, date) => carry + date.tickets.length, 0);
            if (this.loadedPricesCount >= priceCount) {
                this.setPricesAlreadyLoaded(true);
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions('ticketSale', [
            'setPricesAlreadyLoaded',
        ]),
        filteredEventDates() {
            if (!this.isEventOnPresale) return this.singleEventTicketDates;
            const validateTicketBinConfig = (ticket) => ticket.bin_config_id && this.isBinListValidated(this.singleEventInformation.code, this.singleEventInformation.slug, ticket.bin_config_id);
            return this.singleEventTicketDates
                .filter((eventDate) => eventDate.tickets.some(validateTicketBinConfig))
                .map((eventDate) => ({
                    ...eventDate,
                    tickets: eventDate.tickets.filter(validateTicketBinConfig),
                }));
        },
    },
};
